function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#csv_svg__clip0_1238_29966)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.187 5.723h-.384V3.87c0-.011-.002-.023-.004-.035a.308.308 0 00-.074-.203L10.64.107l-.002-.002a.305.305 0 00-.063-.052l-.02-.013a.33.33 0 00-.062-.026L10.476.01A.316.316 0 0010.404 0H2.822a.628.628 0 00-.627.627v5.096h-.384a.897.897 0 00-.897.897v4.663c0 .495.402.897.897.897h.384v3.193c0 .346.281.627.627.627h10.353a.628.628 0 00.628-.627V12.18h.384a.897.897 0 00.897-.897V6.62a.897.897 0 00-.897-.897zM2.822.627h7.268v3.21c0 .174.14.314.314.314h2.771v1.572H2.822V.627zM7.546 9.14c-.779-.271-1.286-.702-1.286-1.383 0-.8.667-1.411 1.772-1.411.529 0 .918.111 1.196.236l-.236.855a2.222 2.222 0 00-.98-.222c-.46 0-.682.208-.682.452 0 .299.264.43.87.66.826.306 1.216.736 1.216 1.397 0 .785-.605 1.453-1.891 1.453-.535 0-1.064-.14-1.328-.285l.216-.876a2.7 2.7 0 001.175.292c.486 0 .743-.202.743-.508 0-.292-.222-.459-.785-.66zm-5.52-.306c0-1.599 1.14-2.488 2.558-2.488.55 0 .966.111 1.154.208l-.215.841a2.296 2.296 0 00-.89-.173c-.841 0-1.494.507-1.494 1.55 0 .938.555 1.529 1.501 1.529.32 0 .674-.07.883-.153l.16.827c-.195.097-.633.202-1.203.202-1.62 0-2.454-1.008-2.454-2.343zm11.15 6.37H2.821V12.18h10.353v3.023zm-.701-4.097h-1.238L9.736 6.421h1.161l.57 1.982c.16.555.306 1.09.417 1.675h.02c.119-.564.265-1.12.425-1.655l.598-2.002h1.126l-1.578 4.685z",
  fill: "#6264A7"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "csv_svg__clip0_1238_29966"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function SvgCsv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgCsv;